import { useRouteLoaderData } from 'react-router';
import type { ISession } from '@/security/session';

const AUTHENTICATED_ROUTE_ID = 'authenticated';

export const useOptionalSession = (): ISession | undefined =>
    useRouteLoaderData(AUTHENTICATED_ROUTE_ID) as ISession | undefined;

export const useSession = (): ISession => {
    const session = useOptionalSession();

    if (!session) {
        throw new Error('useSession must be used inside the authenticated route');
    }

    return session;
};
